import { Component, OnInit, SimpleChanges, OnChanges, OnDestroy, input } from '@angular/core';

// NGRX && NGRX
import { Subscription } from 'rxjs';
import { Store, select } from '@ngrx/store';

// OLCI
import * as fromRoot from '../../../reducers';
import * as olci from '../../../actions/olci';
import { constants } from '../../../constants';
import * as tracking from '../../../actions/tracking';

@Component({
    selector: 'app-language-selector',
    templateUrl: './language-selector.component.html',
    styleUrls: ['./language-selector.component.scss'],
    standalone: false
})
export class LanguageSelectorComponent implements OnInit, OnDestroy, OnChanges {
	public readonly bundle = input<any>({});
	public languageList: any;
	public _languageListSubscription: Subscription;
	public readonly layoutState = input<any>(null);

	public showLanguageSelector = false;

	public constructor(private readonly store: Store<fromRoot.AppState>) {}

	public ngOnInit(): void {
		this._languageListSubscription = this.store.pipe(select(fromRoot.getLanguageList)).subscribe(res => {
			if (res) {
				this.languageList = res.map((obj: any) => {
					return { text: obj.name, val: obj.isocode };
				});
			}
		});
	}

	public ngOnChanges(changes: SimpleChanges) {
		if (changes['layoutState']) {
			const layout = changes['layoutState'];
			if (layout.currentValue && layout.currentValue.openedModalName === constants.MODAL.LANGUAGE) {
				this.showLanguageSelector = true;
				const inert = document.createAttribute('inert');
				document.getElementById('main')?.setAttributeNode(inert);
				this.store.dispatch(new tracking.TrackPageInteractionEventAction('modal: language: choose a language'));
			}
		}
	}

	public ngOnDestroy(): void {
		this._languageListSubscription.unsubscribe();
	}

	public selectlanguage(e: any): void {
		this.showLanguageSelector = false;
		setTimeout(() => {
			this.store.dispatch(new tracking.TrackPageInteractionEventAction('modal: language: selected ' + e.lang.text));
			this.store.dispatch(new olci.CloseModalAction());
		}, 100);
	}

	public closeModal(): void {
		this.showLanguageSelector = false;

		document.getElementById('main')?.removeAttribute('inert');

		setTimeout(() => {
			document.getElementById('my-account-button')?.focus();
			this.store.dispatch(new olci.CloseModalAction());
		}, 0);

		this.store.dispatch(new tracking.TrackPageInteractionEventAction('modal: language: close button'));
	}
}
